// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--1i75V","logo":"header-module--logo--aspGM","link":"header-module--link--AXgy4"};